import React from "react";
import Header from "../../components/marketing/landing/header";
import HeroSection from "../../components/marketing/landing/hero";
import Feature from "../../components/marketing/landing/feature";
import AiFeature from "../../components/marketing/landing/ai-feature";
import Industry from "../../components/marketing/landing/industry";
import Trust from "../../components/marketing/landing/trust";
import CTA from "../../components/marketing/landing/cta";
import Footer from "../../components/marketing/landing/footer";


const LandingPage = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <Header />

      {/* Hero Section */}
      <HeroSection />

      {/* Features Section */}
      <Feature />

      {/* AI Features Section */}
      <AiFeature />

      {/* Industry Solutions */}
      <Industry />

      {/* Trust Section */}
      <Trust />

      {/* CTA Section */}
      <CTA />

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default LandingPage;
